var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-language"}),_vm._v(" "+_vm._s(_vm.local.name)+"\n  ")]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return _c('b-dropdown-item',{key:lang.code,on:{"click":function($event){_vm.selectLanguage(lang)}}},[_vm._v(_vm._s(lang.name))])})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5d082d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Language.vue
// module id = null
// module chunks = 